import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { handleVerifyStudentEmail } from '../../modules/sign-up/redux/enrollment';
import { dispatch } from '../../store';
import { FormattedMessage } from 'react-intl';

class VerifiedStudentEmailPage extends Component {
  componentWillMount () {
    const emailToken = this.props.match.params.verifyEmailToken;
    console.log('studentVerifiedEmailPage, emailToken: ', emailToken);
    dispatch(handleVerifyStudentEmail(emailToken));
  }

  render () {
    return (
      <div>
        <FormattedMessage id='verify-email-sent.main.verifyEmail' />
      </div>
    );
  }
}

export default withRouter(VerifiedStudentEmailPage);
